import { isEqual } from 'lodash';
import { dateFormats, getDateFormatCustom, getTimeFromDate } from '../../utils/date';
import type { Time } from './SetAvailability';
import type { UserCompatibleWithAccountInfo } from '../Login/LoginSlice/types';
import { checkIsAvailable } from '../../utils/helperFunctions';

export const parseUnavailableDate = (date: string | null | undefined): string | undefined => {
  if (!date) return undefined;
  return getDateFormatCustom(date, dateFormats.yearMonthDay);
};

export const parseUnavailableTime = (date: string | null | undefined): Time => {
  if (!date) return { hours: 0, minutes: 0 };
  const time = getTimeFromDate(date);
  const [hours, minutes] = time.split(':');
  return { hours: +hours, minutes: +minutes };
};

export const canDisplayConfirm = (
  stateIsAvailable: boolean,
  date: string | undefined,
  time: Time,
  user: UserCompatibleWithAccountInfo | null
): boolean => {
  const userDataIsAvailable = checkIsAvailable(user?.unavailableUntil ?? null);
  const isAvailableChanged = stateIsAvailable !== userDataIsAvailable;
  if (isAvailableChanged && stateIsAvailable !== false) {
    return true;
  } else {
    if (!date) return false;
    const dateTime = new Date(`${date}T00:00:00`);
    dateTime.setHours(time.hours, time.minutes, 0, 0);
    const isFutureDate = dateTime.getTime() > Date.now();
    const isDateChanged = date !== parseUnavailableDate(user?.unavailableUntil);
    const isTimeChanged = !isEqual(time, parseUnavailableTime(user?.unavailableUntil));
    return isFutureDate && (isDateChanged || isTimeChanged);
  }
};
